import { useQuery } from '@tanstack/react-query';
import { getModule } from '@jwp/ott-common/src/modules/container';
import AccountController from '@jwp/ott-common/src/controllers/AccountController';

export const useExternalLoginProviders = (url: string) => {
  return useQuery({
    queryKey: ['externalProviders', url],
    queryFn: () => getModule(AccountController).getExternalLoginProviders(url),
  });
};
